import '../css/index.css';
import initRecords from './record';
import menuOpen from './menuOpen';
import splitTimelineTitles from './timelineSplit';
import initFloatingBar from './floatingBar';
import initContactForm from './contactForm';

document.addEventListener('DOMContentLoaded', function () {
    menuOpen();
    initRecords();
    splitTimelineTitles();
    initFloatingBar();
    initContactForm();
});
